import React from "react";
import { View } from "react-native";
import { Text } from "../Text";
import { titleStyles as styles } from "./styles";

interface TitleProps {
  title: string;
}

const Title: React.FC<TitleProps> = ({ title }) => (
  <View style={styles.loginTitleContainer}>
    <Text style={styles.loginTitle}>{title}</Text>
  </View>
);

export default Title;
